/**
 * @fileoverview ESM mirror of ../getOwnWebPublicUrl.js.
 *
 * See the CJS source for full documentation. Drift between the two is
 * caught by `tests/esm/native-import.test.mjs`.
 *
 * @module @puffin-core/cross-app-policy/getOwnWebPublicUrl
 */

import { APP_REGISTRY } from './registry.js';
import { extractEnvPrefix } from './extractEnvPrefix.js';
import { stripPort, isLocalhostSource } from './hostMatching.js';

function getOwnWebPublicUrl(appKey, options = {}) {
  const { sourceScheme, sourceHostname, originOverride } = options;

  if (typeof originOverride === 'string' && originOverride.length > 0) {
    return originOverride;
  }

  const entry = APP_REGISTRY[appKey];
  if (!entry) {
    throw new TypeError(
      `getOwnWebPublicUrl: unknown appKey "${appKey}". ` +
        `Known keys: ${Object.keys(APP_REGISTRY).join(', ')}.`,
    );
  }

  // `entry.webDevPort` is a registry invariant (mirrors getOwnApiPublicUrl
  // trusting `entry.defaultDomain`); the frozen registry is the validated SSOT.
  if (isLocalhostSource(sourceScheme, sourceHostname)) {
    return `http://localhost:${entry.webDevPort}`;
  }

  let envPrefix = '';
  if (typeof sourceHostname === 'string' && sourceHostname.length > 0) {
    const subdomain = stripPort(sourceHostname).split('.')[0];
    const derived = extractEnvPrefix(sourceHostname, subdomain, entry.defaultDomain);
    if (typeof derived === 'string') envPrefix = derived;
  }

  const host = envPrefix ? `${envPrefix}.${entry.defaultDomain}` : entry.defaultDomain;
  return `https://${host}`;
}

export { getOwnWebPublicUrl };
